import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

type Product = {
    id: number
    price: number
}

type PurchacePayload = {
    products: Product[]
    billing: {
        name: string
        email: string
        document: string
    }
    delivery: {
        email: string
    }
    payment: {
        card: {
            active: boolean
            owner?: {
                name: string
                document: string
            }
            name?: string
            number?: string
            expires?: {
                month: number
                year: number
            }
            code?: number
        }
        installments: number
    }
}

type PurchaceResponse = {
    orderId: string
}

const api = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://api-ebac.vercel.app/api/eplay'
    }),
    endpoints: (builder) => ({
        getFeatureGame: builder.query<Game, void>({
            query: () => 'destaque'
        }),
        getOnSale: builder.query<Game[], void>({
            query: () => 'promocoes'
        }),
        getSoon: builder.query<Game[], void>({
            query: () => 'em-breve'
        }),
        getActionGames: builder.query<Game[], void>({
            query: () => 'acao'
        }),
        getSportGames: builder.query<Game[], void>({
            query: () => 'esportes'
        }),
        getSimulationGames: builder.query<Game[], void>({
            query: () => 'simulacao'
        }),
        getFightGames: builder.query<Game[], void>({
            query: () => 'luta'
        }),
        getRpgGames: builder.query<Game[], void>({
            query: () => 'rpg'
        }),
        getGame: builder.query<Game, string>({
            query: (id) => `jogos/${id}`
        }),
        purchace: builder.mutation<PurchaceResponse, PurchacePayload>({
            query: (body) => ({
                url: 'checkout',
                method: 'POST',
                body
            })
        })
    })
})

export const {
    useGetFeatureGameQuery,
    useGetOnSaleQuery,
    useGetSoonQuery,
    useGetActionGamesQuery,
    useGetSportGamesQuery,
    useGetSimulationGamesQuery,
    useGetFightGamesQuery,
    useGetRpgGamesQuery,
    useGetGameQuery,
    usePurchaceMutation
} = api

export default api
